/**
 * FERP Portal - Error Monitor Page (Architect Layer)
 *
 * Dedicated page for error tracing and debugging.
 * Real-time monitoring of GraphQL validation errors,
 * backend errors, and HTTP errors.
 */

import React from 'react';
import { Container, Stack, Title, Text } from '@mantine/core';
import { ErrorTracePanel } from '@/components/architect/ErrorTracePanel';

export function ErrorMonitorPage(): React.ReactElement {
  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        {/* Page Header */}
        <div>
          <Title order={1}>Error Monitor</Title>
          <Text c="dimmed" size="lg" mt="xs">
            Real-time error tracing and debugging for GraphQL and backend services
          </Text>
        </div>

        {/* Error Trace Panel */}
        <ErrorTracePanel />
      </Stack>
    </Container>
  );
}

export default ErrorMonitorPage;
